/**
 * autUsrLoginHook
 * @title 세션관련 API Hook
 * @description
 * @param
 * @returns
 * @author 2034263
 * @history
 *   - [2025-12-03] 초기 작성
 */

//내부 라이브러리 모듈
import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';

// 현재 패키지 모듈
import { APIS } from 'scbk-services/constants';
import {
    AutUsrLgnInquirySessionInfoRequest,
    AutUsrLgnInquirySessionInfoResponse,
} from 'scbk-services/session/types';

// 로그아웃 API
export const useAutUsrLgnLogout = (mutationOptions?: UseRestPostMutationOptions<null, null>) => {
    return useRestPost(
        {
            endpoint: APIS.auth.user.login.logout,
        },
        mutationOptions,
    );
};

// 세션연장 API
export const useAutUsrLgnExtendSession = (
    mutationOptions?: UseRestPostMutationOptions<null, null>,
) => {
    return useRestPost(
        {
            endpoint: APIS.auth.user.login.extend,
        },
        mutationOptions,
    );
};

// 세션조회 API
export const useAutUsrLgnInquirySessionInfo = (
    mutationOptions?: UseRestPostMutationOptions<
        AutUsrLgnInquirySessionInfoRequest,
        AutUsrLgnInquirySessionInfoResponse
    >,
) => {
    return useRestPost(
        {
            endpoint: APIS.auth.user.login.inquirySessionInfo,
        },
        mutationOptions,
    );
};
